// extracted by mini-css-extract-plugin
export default {"title":"SignIn_title__6r3W4","subTitle":"SignIn_subTitle__GW1FT","information":"SignIn_information__CCQfw","cancleIcon":"SignIn_cancleIcon__L8BOE"};